import { configureStore } from "@reduxjs/toolkit";
import userReduser from './slice/userSlice'
import coinReduser from './slice/coinSlice'
import orderReducer from './slice/orderSlice'
import historyReducer from './slice/historySlice'

export const store = configureStore({
    reducer: {
        user: userReduser,
        coin: coinReduser,
        order: orderReducer,
        history: historyReducer
    }
})